import moment from 'moment';
import momentDurationFormatSetup from './momentDurationFormat';
import {I18n} from 'react-redux-i18n';

momentDurationFormatSetup(moment);

const momentfs = (...params) => {
  moment.locale(I18n.t('configuration.location'));
  return moment(...params);
};

momentfs.duration = moment.duration;

export const DATETIME_FORMAT_IN_ISO = "D MMM, HH:mm";
export const TIME_FORMAT_IN_ISO = "HH:00";

export const formatWeekDisplay = (value) => {
  if(value){
    return `${moment(value).isoWeekYear()}-W${moment(value).isoWeek()}`;
  }
  return value;
}

export default momentfs;
